<template>
  <div class="about-links" data-testid="about-links">
    <Heading class="about-links__title" :level="2">Mais</Heading>
    <Row
      v-if="aboutData?.paidEventConfig"
      :class="paidEventsClass"
      :left-title="aboutData.paidEventConfig.button.title"
      :left-subtitle="aboutData.paidEventConfig.button.description"
      :has-interaction="aboutData.paidEventConfig.enabled"
      :chevron="aboutData.paidEventConfig.enabled"
      @click="openConfigurationModal"
    >
      <template #icon-left>
        <InitialAvatarIcon icon="BA0040" size="medium" />
      </template>
    </Row>
    <router-link
      v-if="showIncomeTax"
      :to="{ name: 'incomeTaxCalculator', query: { goBack: 'true' } }"
    >
      <Row left-title="Calculadora de IR" chevron has-interaction>
        <template #icon-left>
          <InitialAvatarIcon icon="EF0040" size="small" />
        </template>
      </Row>
    </router-link>
    <router-link
      :to="{
        name: 'wealthPortfolioStatementsAndBrokerageNotes',
        params: { portfolioId: portfolioId }
      }"
    >
      <Row left-title="Extratos e Notas" chevron has-interaction>
        <template #icon-left>
          <InitialAvatarIcon icon="ED0030" size="small" />
        </template>
      </Row>
    </router-link>
    <router-link :to="faqRoute">
      <Row left-title="Ajuda" chevron has-interaction>
        <template #icon-left>
          <InitialAvatarIcon icon="EF0051" size="small" />
        </template>
      </Row>
    </router-link>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router/composables';

import { Heading, Row, InitialAvatarIcon } from '@warrenbrasil/nebraska-web';
import { CustomerModule } from '@/modules/common/store/CustomerModule';

import { PortfolioAboutData } from '@/modules/wealth/services/portfolio';

interface Props {
  aboutData: PortfolioAboutData;
}
const props = defineProps<Props>();

const route = useRoute();
interface Emit {
  (e: 'toggle-configuration-modal'): void;
}
const emit = defineEmits<Emit>();

const portfolioId = computed(() => {
  return route.params.portfolioId;
});

const paidEventsClass = computed(() => {
  return {
    'about-links__paid-events--disabled':
      !props.aboutData?.paidEventConfig?.enabled
  };
});

const openConfigurationModal = () => {
  if (!props.aboutData?.paidEventConfig?.enabled) return;

  emit('toggle-configuration-modal');
};

const faqRoute = computed(() => {
  if (props.aboutData?.faq?.id) {
    return {
      name: 'help-center-section',
      params: {
        id: props.aboutData.faq.id
      }
    };
  }
  return { name: 'help-center' };
});

const isCustomerPJ = computed(() => {
  return !!CustomerModule?.getCustomer?.professionalProfile;
});

const showIncomeTax = computed(() => {
  return !isCustomerPJ.value && !CustomerModule?.isImpersonated;
});
</script>

<style lang="less" scoped>
.about-links {
  &__title {
    margin-bottom: @size-spacing-x400;
  }

  &__paid-events--disabled {
    cursor: not-allowed;
    color: @base-disabled;

    .initial-avatar-icon {
      background: @base-disabled;
      color: @base-over-disabled;
    }

    :deep(.text-p-5) {
      color: @base-disabled;
    }
  }
}
</style>
